import { render, staticRenderFns } from "./BotOnePlatformGroupSendDetail.vue?vue&type=template&id=6aa9a209&"
import script from "./BotOnePlatformGroupSendDetail.vue?vue&type=script&lang=js&"
export * from "./BotOnePlatformGroupSendDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports